"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightedValueFactory = void 0;
/**
 * Responsible for constructing {@link HighlightedValue}s
 */
class HighlightedValueFactory {
    /**
     * Constructs an array of {@link HighlightedValue}s
     *
     * @param data The raw highlightedFields data from the knowledge graph
     */
    static create(data) {
        return this.createRecursively(data);
    }
    /**
     * Constructs an array of {@link HighlightedValue}s
     *
     * @param data The raw highlightedFields data from the knowledge graph
     * @param path The path to the current field which reflects its nested structure
     */
    static createRecursively(data, path = []) {
        if (typeof data !== 'object' || data === null) {
            return [];
        }
        const highlightedValues = [];
        Object.entries(data).forEach(([fieldName, highlightedField]) => {
            const currentPath = [...path];
            currentPath.push(fieldName);
            if (this.isChildHighlightedField(highlightedField)) {
                const value = highlightedField.value;
                const matchedSubstrings = highlightedField.matchedSubstrings;
                const highlightedValue = this.from(value, fieldName, currentPath, matchedSubstrings);
                highlightedValues.push(highlightedValue);
            }
            else {
                const nestedHighlightedValues = this.createRecursively(data[fieldName], currentPath);
                highlightedValues.push(...nestedHighlightedValues);
            }
        });
        return highlightedValues;
    }
    /**
     * Constructs a single {@link HighlightedValue}
     */
    static from(value, fieldName, path, matchedSubstrings) {
        return Object.freeze({
            value: value,
            fieldName: fieldName,
            path: path,
            matchedSubstrings: matchedSubstrings
        });
    }
    /**
     * Determines whether or not a field is a {@link ChildHighlightedField}
     *
     * @param field
     */
    static isChildHighlightedField(field) {
        return field.value !== undefined &&
            field.matchedSubstrings !== undefined;
    }
}
exports.HighlightedValueFactory = HighlightedValueFactory;
